import _ from 'lodash';
import { lsApiService, lsErrorService } from 'ls-vue-common';
import {
  FEATURE_FLAGS__MUTATE_FLAGS,
  FEATURE_FLAGS__GET_FLAGS,
  FEATURE_FLAGS__REGISTER_EXPOSURE,
  FEATURE_FLAGS__ALL_FLAGS,
} from '@/store/types';

const createInitialState = () => {
  return {
    flags: {},
  };
};

export const mutations = {
  [FEATURE_FLAGS__MUTATE_FLAGS](state, payload) {
    state.flags = { ...state.flags, ...payload };
  },
};

export const actions = {
  [FEATURE_FLAGS__GET_FLAGS]({ commit }) {
    return lsApiService
      .request({
        method: 'GET',
        route: '/flags',
      })
      .then(({ data }) => {
        commit(FEATURE_FLAGS__MUTATE_FLAGS, data);
      })
      .catch((error) => {
        lsErrorService.log({ error });
      });
  },

  // allows the backend to track which flags are in use
  [FEATURE_FLAGS__REGISTER_EXPOSURE]({ state }, { flag }) {
    if (!_.get(state.flags, [flag])) {
      return;
    }

    return lsApiService
      .request({
        method: 'GET',
        route: `/flags/${flag}`,
      })
      .catch((error) => {
        lsErrorService.log({ error });
      });
  },
};

export const getters = {
  [FEATURE_FLAGS__ALL_FLAGS](state) {
    return state.flags;
  },
};

export const featureFlags = {
  state: createInitialState,
  mutations,
  actions,
  getters,
};
